import { useEffect } from 'react'

export default function WorkWithGrace() {
  useEffect(() => {
    document.title = 'Environmental Equipment Supply Partner in Yixing | Grace Wang'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">CLEAR SCOPE · CLEAR RESPONSIBILITY</p>
        <h1>Work with a Project Supply Partner in Yixing</h1>
        <p>Choose a clearly defined supply and coordination scope according to your role, project stage and technical requirements.</p>
      </section>

      <section className="page-content">
        <h2>EPC Contractors & Engineering Companies</h2>
        <p><strong>Project-Specific Equipment Supply</strong></p>
        <p>Support for defined equipment packages, fabricated components and auxiliary systems. This includes written scope clarification, suitable manufacturing partner selection, proposal coordination, production follow-up, inspection documentation and export preparation.</p>

        <h2>Technology Providers & Equipment Manufacturers</h2>
        <p><strong>Additional Manufacturing Capacity</strong></p>
        <p>Drawing-based fabrication, complementary equipment and non-core balance-of-plant packages produced by selected specialist manufacturing partners.</p>

        <h2>Distributors & Local Partners</h2>
        <p><strong>Product and Supply Development</strong></p>
        <p>Selected equipment categories, private-label discussions, samples, technical files, factory coordination and commercial review.</p>

        <h2>End Users</h2>
        <p><strong>Equipment Inquiry Coordination</strong></p>
        <p>Translate operating problems and site requirements into a structured equipment inquiry, then coordinate a suitable manufacturing and technical review.</p>
      </section>
    </div>
  )
}
